import root from 'window-or-global';
import { action, computed, observable } from 'mobx';
import LanguageService from '../services/Language.service';
import KenticoClient from '../services/kenticoClient';
import { LANGUAGES } from '../common/consts/languages';

import history from '../history';

export class AppStore {
  @observable currentLanguage = LanguageService.getInitialLanguage();

  @observable previousPathname = root.location.pathname;

  @observable referrer = root.document.referrer;

  @observable currentUrl = root.location.href;

  @observable previousUrl;

  @computed
  get isPolishLanguage() {
    return this.currentLanguage === LANGUAGES.PL.value;
  }

  @computed
  get isEnglishLanguage() {
    return this.currentLanguage === LANGUAGES.EN.value;
  }

  @computed
  get isFranceLanguage() {
    return this.currentLanguage === LANGUAGES.FR.value;
  }

  constructor() {
    this.initStore();
  }

  @action
  initStore() {
    this.checkLanguagePath(history.location.pathname);
    history.listen((location) => {
      this.checkLanguagePath(location.pathname);
    });
  }

  @action
  setLanguage(language, saveInStorage = false) {
    if (LanguageService.hasLanguageAvailable(language)) {
      this.currentLanguage = language;
      KenticoClient.setLanguage(language);
      if (saveInStorage) {
        LanguageService.updateLanguageLocalStorage(language);
      }
    }
  }

  @action
  checkLanguagePath(pathname) {
    const lang = LanguageService.getLanguageByRouteLogic(
      pathname,
      this.previousPathname,
    );
    this.previousPathname = pathname;
    if (this.currentLanguage !== lang.language) {
      this.setLanguage(lang.language || this.currentLanguage, lang.shouldSave);
    }
  }

  @action
  setUrlHistory() {
    const currentUrl = root.parent.location.href;
    if (this.currentUrl !== currentUrl) {
      this.previousUrl = this.currentUrl;
    }
    this.currentUrl = currentUrl;
  }
}

export default new AppStore();



// WEBPACK FOOTER //
// ./src/stores/App.store.js